// Tutorials data structure for the Tutorials page

export type TutorialDifficulty = 'beginner' | 'intermediate' | 'advanced';

export interface Tutorial {
    id: string;
    slug: string;
    title: string;
    description: string;
    content: string; // Markdown or rich text content
    category: string;
    difficulty: TutorialDifficulty;
    duration: number; // minutes
    techStack: string[];
    thumbnail?: string;
    dateAdded: string;
    lastUpdated: string;
    tags: string[];
    prerequisites?: string[];
    githubRepo?: string;
    liveDemo?: string;
    featured?: boolean;
}

export interface TutorialCategory {
    id: string;
    name: string;
    color: string;
}

export const tutorialCategories: TutorialCategory[] = [
    { id: 'frontend', name: 'Frontend Development', color: '#3B82F6' },
    { id: 'ai', name: 'AI & Machine Learning', color: '#10B981' },
    { id: 'mobile', name: 'Mobile Development', color: '#8B5CF6' },
    { id: 'backend', name: 'Backend Systems', color: '#F59E0B' },
    { id: 'devops', name: 'DevOps & Infrastructure', color: '#EF4444' },
    { id: 'productivity', name: 'Productivity & Tools', color: '#6366F1' },
];

export const tutorials: Tutorial[] = [
    {
        id: 'premium-portfolio-lovable-cursor',
        slug: 'premium-portfolio-lovable-cursor',
        title: 'Build Premium Portfolio with Lovable AI & Cursor',
        description: 'Complete step-by-step guide to creating a professional portfolio website using Lovable AI, enhancing it with Cursor AI, and deploying to Vercel.',
        content: '/tutorials/premium-portfolio-lovable-cursor.md',
        category: 'frontend',
        difficulty: 'beginner',
        duration: 45,
        techStack: ['Lovable AI', 'Cursor AI', 'GitHub', 'Vercel', 'Node.js', 'React'],
        thumbnail: '/images/tutorials/premium-portfolio-lovable-cursor.png',
        dateAdded: '2025-01-15',
        lastUpdated: '2025-01-15',
        tags: ['portfolio', 'ai-tools', 'deployment', 'web-development', 'beginner-friendly'],
        prerequisites: ['Node.js installed', 'Basic computer skills', 'Internet connection'],
        githubRepo: '',
        liveDemo: '',
        featured: true,
    },
    // Commented out simple-tasks-todo-app tutorial
    // {
    //     id: 'simple-tasks-todo-app',
    //     slug: 'simple-tasks-todo-app',
    //     title: 'Simple Tasks: Todo App with Expo',
    //     description: 'A step-by-step guide to building a minimal yet powerful todo app using Expo and React Native.',
    //     content: '/tutorials/simple-tasks-todo-app.md', // path to markdown file
    //     category: 'mobile',
    //     difficulty: 'beginner',
    //     duration: 20,
    //     techStack: ['React Native', 'Expo', 'JavaScript'],
    //     thumbnail: '/images/tutorials/simple-tasks-todo-app.png',
    //     dateAdded: '2024-06-01',
    //     lastUpdated: '2024-06-01',
    //     tags: ['todo', 'expo', 'react-native', 'mobile'],
    //     prerequisites: ['Basic JavaScript', 'Node.js installed'],
    //     githubRepo: 'https://github.com/GauravGadhari/simple-tasks-todo-app',
    //     liveDemo: '',
    //     featured: true,
    // },
    {
        id: 'expo-apk-beginner',
        slug: 'expo-apk-beginner',
        title: 'Create Your First APK with Expo (Hindi)',
        description: 'Step-by-step video guide to building and exporting your first APK with Expo. No coding required! Hindi walkthrough for beginners.',
        content: '/tutorials/expo-apk-beginner.md',
        category: 'mobile',
        difficulty: 'beginner',
        duration: 15,
        techStack: ['Expo', 'React Native', 'VS Code', 'Node.js'],
        thumbnail: 'https://img.youtube.com/vi/m2_gJtPWnH8/maxresdefault.jpg',
        dateAdded: '2024-06-09',
        lastUpdated: '2024-06-09',
        tags: ['expo', 'apk', 'react-native', 'beginner', 'video'],
        prerequisites: ['Basic computer skills', 'Android phone'],
        githubRepo: '',
        liveDemo: 'https://www.youtube.com/watch?v=m2_gJtPWnH8',
        featured: true,
    },
]; 